import { render, staticRenderFns } from "./PropertyRatings.vue?vue&type=template&id=98bc6b1a"
import script from "./PropertyRatings.vue?vue&type=script&lang=ts"
export * from "./PropertyRatings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports